
import { Component, Vue } from "vue-property-decorator";
import { namespace } from "vuex-class";
import { emptyToLine, splitThousands } from "@common/src/utils/common";
import t from "@common/src/i18n/t";
import { Table } from "@common/src/utils/decorator";
import { addCurrencyUnit } from "@common/src/utils/tools";

import dayjs from "dayjs";
const setting = namespace("setting");
const base = namespace("base");
const staff = namespace("staff");
const purchase = namespace("purchase");
const supplier = namespace("supplier");
const parts = namespace("parts");
const inventory = namespace("inventory");

@Component({
  components: {}
})
@Table("loadListData")
export default class PurchaseRefundList extends Vue {
  dayjs = dayjs;
  @base.Action getDictionaryList;
  @parts.Action getPartsList;
  @staff.Action getStaffList;
  @purchase.Action purchaseComplete;
  @purchase.Action getReturnPurchasePageModelPage;
  @purchase.Action receiveReturnPurchase;
  @purchase.Action outBoundReturnPurchase;
  @purchase.Action getReturnPurchaseModel;
  @inventory.Action queryInventoryAndNotice;
  @supplier.Action getSupplierList;
  @setting.Action getPatternPaymentList;
  emptyToLine = emptyToLine;
  splitThousands = splitThousands;
  addCurrencyUnit = addCurrencyUnit;
  orderList: any[] = [];
  payWayList: any = [];
  receiveFormData: any = {
    paidAmount: "",
    paidMethod: "",
    paidMethodDesc: "",
    returnPurchaseNo: "",
    remark: ""
  };
  receiveFormDataRules: any = {
    paidMethod: [{ required: true, message: t("v210901.please-select-the-pay-way"), trigger: "change" }]
  };
  searchForm = {
    returnPurchaseNo: "", // 退货单号
    supplierName: "", // 供应商名称
    returnStatus: "", // 退货状态,created-已创建,issued-已出库,cancelled-已取消
    receiptStatus: "", // 是否已收款
    partsName: "", // 零配件名称
    returnReason: "", // 退货原因,unsalable-滞销,damaged-损坏,other-其他
    returnStartTime: "", // 退货日期 起始, yyyy-MM-dd
    returnEndTime: "", // 退货日期 结束, yyyy-MM-dd
    purchaseNo: "" // 采购单号
  };
  showReceive: boolean = false;
  showOutbound: boolean = false;
  handleComfirmCommand(command) {
    switch (command) {
      case "outbound":
        this.showOutbound = true;
        break;
      case "receive":
        this.showReceive = true;
        break;
      default:
        break;
    }
  }
  getPayWayList() {
    this.getPatternPaymentList({
      status: "1"
    }).then(data => {
      this.payWayList = this.$safeValue(data, "data", []);
    });
  }
  handleConfirmOutbound() {
    this.outBoundReturnPurchase({
      returnPurchaseNo: this.willUpdateRow.returnPurchaseNo
    }).then(data => {
      this.showOutbound = false;
      this.$message.success(t("warehouse.outbound-success"));
      this.loadListData();
      if (data.data.validateInventoryAlert === "1") {
        this.getReturnPurchaseModel({
          returnPurchaseNo: this.willUpdateRow.returnPurchaseNo
        }).then(data => {
          const partsCodeList = data.data.returnPurchaseDetailList.map(item => item.partsCode);
          if (partsCodeList && partsCodeList.length > 0) {
            this.queryInventoryAndNotice(partsCodeList);
          }
        });
      }
    });
  }
  handleConfirmReceive() {
    if (!this.receiveFormData.paidMethod) {
      return this.$message.error(t("v210901.please-select-the-pay-way"));
    }
    this.receiveFormData.paidMethodDesc = this.payWayList.find(
      v => v.payMethodCode === this.receiveFormData.paidMethod
    ).payMethodName;
    this.receiveFormData.returnPurchaseNo = this.willUpdateRow.returnPurchaseNo;
    this.receiveReturnPurchase(this.receiveFormData).then(() => {
      this.showReceive = false;
      this.$message.success(t("service.payment-success"));
      this.loadListData();
    });
  }
  created() {
    this.init();
    this.loadListData();
  }
  settlementList: any = [];
  orderStatusList: any[] = [];
  returnReasonList: any = [];
  returnStatusList: any = [];
  returnSettlementList: any = [];
  init() {
    // 获取供应商
    this.searchSupplier();
    this.searchPartsList();
    // 结算方式字典List
    this.getDictionaryList("purchase_settlement_status").then(data => {
      this.settlementList = data;
    });
    // 订单状态字典List
    this.getDictionaryList("purchase_status").then(data => {
      this.orderStatusList = data;
    });
    this.getDictionaryList("return_reason").then(data => {
      this.returnReasonList = data;
    });
    this.getDictionaryList("return_status").then(data => {
      this.returnStatusList = data;
    });
    // 退款收款状态List
    this.getDictionaryList("purchase_return_receipt_status").then(data => {
      this.returnSettlementList = data;
    });
    this.getPayWayList();
  }
  @Table.LoadDataMethod()
  loadListData() {
    return this.getReturnPurchasePageModelPage({
      ...this.searchForm,
      orderItems: this.mix_sortParams,
      pageNum: this.mix_pageNum,
      pageSize: this.mix_pageSize
    }).then(data => {
      this.orderList = data.data.list;
      return data;
    });
  }
  handleSwitchStatus() {
    this.mix_pageNum = 1;
    this.loadListData();
  }
  handleComplete() {
    this.purchaseComplete({
      purchaseNo: this.willUpdateRow.purchaseNo
    }).then(() => {
      this.$message.success(t("warehouse.inbound-success"));
      this.loadListData();
    });
  }
  get searchList() {
    return [
      {
        label: t("v210901.return-order-no"),
        type: "input",
        value: "",
        prop: "returnPurchaseNo"
      },
      {
        label: t("supplier.name"),
        type: "select-search",
        value: "",
        prop: "supplierName",
        placeholder: t("v210831.enter-supplier-keyword"),
        selectList: this.supplierList,
        searchFun: this.searchSupplier
      },
      {
        label: t("v210901.return-status"),
        type: "select",
        selectList: this.returnStatusList,
        value: "",
        prop: "returnStatus"
      },
      {
        label: t("v210901.collection-status"),
        type: "select",
        selectList: this.returnSettlementList,
        value: "",
        prop: "receiptStatus"
      },
      {
        label: t("parts.text"),
        type: "select-search",
        value: "",
        prop: "partsName",
        placeholder: t("v210901.enter-spare-parts-search"),
        selectList: this.partsList,
        searchFun: this.searchPartsList
      },
      {
        label: t("v210901.reason-for-return"),
        type: "select",
        selectList: this.returnReasonList,
        value: "",
        prop: "returnReason"
      },
      {
        label: t("v210901.return-date"),
        type: "daterange",
        value: "",
        prop: "purchaseDate",
        valueFormat: "yyyy-MM-dd",
        valueDistribute: ["returnStartTime", "returnEndTime"]
      },
      {
        label: t("purchase.purchase-no"),
        type: "input",
        value: "",
        prop: "purchaseNo"
      }
    ];
  }
  handleSearch(data) {
    this.mix_pageNum = 1;
    data.forEach(item => {
      if (item.prop) {
        if (item.prop === "supplierName") {
          let supplierName = this.supplierList.find(v => v.value === item.value);
          supplierName = supplierName ? supplierName.label : "";
          this.searchForm["supplierName"] = supplierName;
        } else if (item.prop === "partsName") {
          let partsName = this.partsList.find(v => v.value === item.value);
          partsName = partsName ? partsName.label : "";
          this.searchForm["partsName"] = partsName;
        } else {
          this.searchForm[item.prop] = item.value;
        }
      }
    });
    this.loadListData();
  }
  supplierList: any = [];
  searchSupplier(val = "") {
    this.getSupplierList({
      pageNum: 1,
      pageSize: 10,
      supplierName: val
    }).then(data => {
      this.supplierList = this.$safeValue(data, "data.list", []).map(item => {
        item.label = item.supplierName;
        item.value = item.supplierCode;
        return item;
      });
    });
  }
  partsList: any = [];
  searchPartsList(val = "") {
    this.getPartsList({
      pageNum: 1,
      pageSize: 10,
      partsName: val
    }).then(data => {
      this.partsList = (data.data?.list || []).map(item => {
        item.label = item.partsName;
        item.value = item.partsCode;
        return item;
      });
    });
  }
  willUpdateRow: any = {};
  handleSetCurrentRow(visible, row) {
    if (visible) {
      this.willUpdateRow = row;
      this.receiveFormData.paidAmount = this.willUpdateRow.returnPurchaseAmount;
    }
  }
  handleEdit(row) {
    this.$router.push(`/purchase/purchase-refund-edit/${row.returnPurchaseNo}`);
  }
  handleLinkOrderView(row) {
    let { href } = this.$router.resolve({
      path: `/purchase/purchase-view/${row.purchaseNo}`
    });
    window.open(href, "_blank");
  }
  handleView(row) {
    let { href } = this.$router.resolve({
      path: `/purchase/purchase-refund-view/${row.returnPurchaseNo}`
    });
    window.open(href, "_blank");
  }
}
